import React from 'react';
import oktaAuth from '../../auth/oktaAuth';
import './LoginButton.css';

const LoginButton = ({ onLoginSuccess }) => {
  const handleLogin = () => {
    const params = new URLSearchParams(window.location.search);
    const redirect = params.get('redirect');
    oktaAuth.signInWithRedirect({ originalUri: redirect || '/home' });
  };

  return (
    <button onClick={handleLogin} className="login-button">
      SSO Login
    </button>
  );
};

export default LoginButton;
